import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import FilterLinksItem from './FilterLinksItem';

import type { FilterLinksProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/FilterLinks';

import STYLE from './FilterLinks.module.scss';

const FilterLinks = ({ filters, title }: FilterLinksProps) => (
  <div className="FilterLinks">
    <BpkText tag="h2" textStyle={TEXT_STYLES.heading4}>
      {title}
    </BpkText>
    <div className={STYLE.FilterLinks__FilterList}>
      {filters.map((props, categoryIndex) => (
        <FilterLinksItem
          key={props.name}
          {...props}
          categoryIndex={categoryIndex}
          trackingVariant="desktop"
        />
      ))}
    </div>
  </div>
);

export default FilterLinks;
